export default "__VITE_ASSET__BVMUZ0ca__"